import React from "react";
import "./ConfigPane.scss";

import PalamoaInputField from "../PalamoaInputField";

import { CompactPicker } from "react-color";
import { withTranslation } from 'react-i18next';


class ConfigPaneFormRow extends React.Component {
  onBlur(evt) {
    console.log("ConfigPaneFormRow onBlur", evt);
    let { onBlur } = this.props;
    // evt.relatedTarget gives the element on which was clicked, which caused the input to lose focus.
    // We want to unset focus (this.onInputFocus(-1);) on every click, except on a JSON field in the <pre>
    // Unfortunately relatedTarget is only populated with nodes, that are focusable. To force a node to be focusable,
    // i put an "tabindex="0" on every JSON val.

    if (
      !(
        evt.relatedTarget &&
        (evt.relatedTarget.classList.contains("jsh-val") ||
          evt.relatedTarget.classList.contains(
            "palamoa-input-field-clearbutton"
          ))
      )
    ) {
      onBlur(evt);
    }
  }

  renderColorSelector(color) {
    let { 
      //onBlur, 
      onManualEdit, 
      onFocus, 
      value } = this.props;
    value = value || "black";
    return (
      <div
        className="configpane-form-row-colorselector"
        style={{ background: color }}
      >
        <CompactPicker
          height={"100%"}
          width={"100%"}
          colors={[
            "#000000",
            "#0084FF",
            "#6300FF",
            "#F44E3B",
            "#FE9200",
            "#009688",
            "#DBDF00"
          ]}
          color={value}
          onChange={c => {
            console.log(c.hex);
            onFocus();
            onManualEdit({ target: { value: c.hex } });
          }}
        />
      </div>
    );
  }

  render() {
    let {
      label = "No Label",
      value = "",
      onFocus,
      isFocused,
      method,
      onManualEdit,
      onClear,
      isLegend,
      isColor,
      isValue,
      //onBlur,
      toggleTransforms,
      transformedValue,
      isTransformRow,
      t
    } = this.props;

    if (isLegend) {
      return this.renderLegendVersion();
    }

    let mode;

    if (method === "JSON") {
      mode = 0;
    } else if (method === "manual") {
      mode = 1;
    }

    let transformButtonCSSClass = "function_button";
    transformButtonCSSClass += transformedValue ? " active" : "";

    let labelCSSClass = "configpane-form-row-label";
    labelCSSClass += isTransformRow ? " isTransformRow" : "";

    return (
      <div className="configpane-form-row">
        <div className={labelCSSClass}>{label}</div>
        <div className="configpane-form-row-indicators">
          <ConfigPaneFormRowIndicator text={"JSON"} active={mode === 0} />
          <ConfigPaneFormRowIndicator text={t("manual_word")} active={mode === 1} />
        </div>
        <div
          className="configpane-form-row-input"
          onFocus={onFocus}
          onBlur={evt => {
            if (isColor){
              this.onBlur({...evt,...{ target: { value: value } }});
            }
          }} 
        >
          <PalamoaInputField
            isFocused={isFocused}
            value={value}
            transformedValue={transformedValue}
            method={method}
            onChange={onManualEdit}
            onClick={onFocus}
            onBlur={this.onBlur.bind(this)}
            onClear={onClear}
          />
          {isValue && (
            <button
              className={transformButtonCSSClass}
              onClick={toggleTransforms}
            >
              {" "}
              ƒ {transformedValue ? "⟶" : ""} {transformedValue}
            </button>
          )}
          {isValue && <p>{}</p>}
          {isColor ? this.renderColorSelector(value) : null}
        </div>
      </div>
    );
  }

  renderLegendVersion() {
    let { t } = this.props;
    return (
      <div className="configpane-form-row">
        <div className="configpane-form-row-label" />
        <div className="configpane-form-row-indicators">
          <div className="configpane-form-row-indicator-legend">JSON</div>
          <div className="configpane-form-row-indicator-legend">{t("manual_word")}</div>
        </div>
        <div className="configpane-form-row-input" />
      </div>
    );
  }
}

export default withTranslation()(ConfigPaneFormRow);

const ConfigPaneFormRowIndicator = props => {
  let { active = false } = props;
  let cssClass = "configpane-form-row-indicator";
  cssClass += active ? " active" : "";
  return <div className={cssClass} />;
};
